<template>
  <div class="agreement-with-policy">
    <label>
      <input
        v-model="isAccept"
        type="checkbox"
        class="checked"
      />
      <span class="h5">
        Я даю согласие на обработку персональных данных и принимаю <nuxt-link to="/policy" rel="nofollow" target="_blank">политику конфиденциальности</nuxt-link>. Перед отправкой ознакомьтесь, пожалуйста, с <nuxt-link to="/pravila-publikacii" rel="nofollow" target="_blank">правилами публикации</nuxt-link>.
      </span>
    </label>
  </div>
</template>

<script setup lang="ts">
import type {ModelRef} from "vue";

const isAccept: ModelRef<boolean | undefined> = defineModel();

</script>

<style scoped lang="scss">
.agreement-with-policy {
  label {
    display: flex;
    //align-items: center;
    cursor: pointer;

    span, h5 {
      line-height: 100%;
      margin-left: 16px;
      font-size: 14px;
    }

    input {
      border-color: #B8B8B8;
    }

    input:checked {
      border-color: black;
    }
  }
  span {
    flex: 1;
  }
  a {
    text-decoration: underline;
    font-weight: 500;
    color: var(--text-link-silver);
    transition: all 0.2s ease-in-out;
    &:hover {
     text-decoration: none;
    }
  }
}
@media screen and (max-width: 1023px) {
  .agreement-with-policy {
    span, h5 {
      line-height: 100%;
      font-size: 12px;
    }
  }
}
</style>
